var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProjectVehicleIcon = function SvgProjectVehicleIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ELEMENT|ICON|Vehicle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 4.37305H12.7499",
    stroke: "#6B7785",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.43945 1.07812V4.37224",
    stroke: "#6B7785",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.57589 9.07743C4.39769 9.07743 5.06389 8.44537 5.06389 7.66567C5.06389 6.88597 4.39769 6.25391 3.57589 6.25391C2.75409 6.25391 2.08789 6.88597 2.08789 7.66567C2.08789 8.44537 2.75409 9.07743 3.57589 9.07743Z",
    stroke: "#6B7785",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.52706 9.07743C10.3489 9.07743 11.0151 8.44537 11.0151 7.66567C11.0151 6.88597 10.3489 6.25391 9.52706 6.25391C8.70526 6.25391 8.03906 6.88597 8.03906 7.66567C8.03906 8.44537 8.70526 9.07743 9.52706 9.07743Z",
    stroke: "#6B7785",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.4272 1.85836C11.1752 1.38024 10.6599 1.07812 10.0964 1.07812H1.992C1.44392 1.07812 1 1.4993 1 2.0193V7.19577C1 7.45553 1.22221 7.66636 1.496 7.66636H2.088C2.088 6.88659 2.75413 6.25459 3.576 6.25459C4.39787 6.25459 5.064 6.88659 5.064 7.66636H8.04C8.04 6.88659 8.70613 6.25459 9.528 6.25459C10.3499 6.25459 11.016 6.88659 11.016 7.66636H12.504C12.7778 7.66636 13 7.45553 13 7.19577V4.84283L11.4272 1.85836Z",
    stroke: "#6B7785",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProjectVehicleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "project-vehicle-icon.4f2173755a3027e63ecc2448afed20f0.svg";